// App
import { useSelector } from 'react-redux';

interface ReduxState {
  filter: {
    commute: {
      commuteLats: Array<number>;
      commuteLons: Array<number>;
      commuteTime: number | null;
    };
  };
}

export const useCommuteFilterButtonStatus = () => {
  // Redux
  const commuteState = useSelector((state: ReduxState) => state.filter.commute);

  // If Commute Lat or Lon is present, this filter is active
  if (commuteState.commuteLats && commuteState.commuteLons && commuteState.commuteTime !== null) {
    return true;
  }

  return false;
};
